import React, { useState } from "react";
import { Switch } from "@nextui-org/react";
import Cookies from "js-cookie";

const SwitchLang = () => {
  const locale = Cookies.get("locale") || "id";
  const [language, setLanguage] = useState(locale);

  const changeLang = () => {
    if (language === "en" && locale === "en") {
      setLanguage("id");
      Cookies.set("locale", "id");
      window.location.reload();
    } else {
      setLanguage("en");
      Cookies.set("locale", "en");
      window.location.reload();
    }
  };
  return (
    <div className="mb-6 flex items-center space-x-3">
      <div
        className={`text-sm font-medium  ${language === "id" ? "text-purple-600" : "text-gray-500"}`}
      >
        ID
      </div>
      {/* <Switch defaultSelected size="sm" /> */}
      <div className="form-switch focus-within:outline-blue">
        <input
          type="checkbox"
          id="toggle"
          className="sr-only"
          checked={language === "en" && locale === "en"}
          onChange={() => changeLang()}
        />
        <label className="bg-gray-400" htmlFor="toggle">
          <span className="bg-white shadow-sm" aria-hidden="true"></span>
          <span className="sr-only">ID</span>
        </label>
      </div>
      <div
        className={`text-sm font-medium  ${language === "en" ? "text-purple-600" : "text-gray-500"}`}
      >
        EN
      </div>
    </div>
  );
};

export default SwitchLang;
